import * as React from 'react';

import { AppProgressBar } from "./AppProgressBar";
import { AppMessageBox } from './AppMessageBox';
import { AppComponentStoreContext} from './stores/appComponentStore';


type Props = {
    children?: React.ReactNode
}

export const AppProvider = (props:Props) => {
    const store = AppComponentStoreContext.createStore();

    return(
        <AppComponentStoreContext.Provider value={store}>
            {props.children}
            <AppProgressBar />
            <AppMessageBox />
        </AppComponentStoreContext.Provider>
    );
}